import { graphql } from "gatsby";
import {
  BackgroundWrapperBlock as BackgroundWrapperBlockCore,
  SimplifyGatsbyQuery,
  backgroundWrapperBlockLivePreviewConfig,
  withLivePreview,
} from "@parksandresorts/core";
import SiteBlocks from "components/blocks/site-blocks/site-blocks";

type Props = {
  //These props are added from another source than the Gatsby Query
  blockInOverlay: boolean;
  locationState: any;
} & SimplifyGatsbyQuery<Queries.BackgroundWrapperBlockFragment>;

const BackgroundWrapperBlock = ({
  contentful_id,
  blocks,
  blockInOverlay,
  backgroundColorHex,
  backgroundMode,
  backgroundPattern,
  backgroundPatternCover,
  imageOpacity,
  topPattern,
  locationState,
}: Props) => {
  const extendedBlocks =
    blocks?.map((block) => {
      return {
        ...block,
        blockInOverlay: blockInOverlay,
        locationState: locationState,
      };
    }) ?? [];

  const currentMode =
    backgroundMode?.toUpperCase() === "DARK" ? "DARK" : backgroundMode?.toUpperCase() === "LIGHT" ? "LIGHT" : undefined;

  return (
    <BackgroundWrapperBlockCore
      contentfulId={contentful_id}
      backgroundColor={backgroundColorHex?.value}
      imageUrls={{
        default: backgroundPattern?.file?.url,
        highQuality: backgroundPattern?.highQuality?.images.fallback?.src ?? "",
        lowQuality: backgroundPattern?.lowQuality?.images.fallback?.src ?? "",
      }}
      opacity={imageOpacity}
      backgroundAsCover={backgroundPatternCover}
      sectionClassName="background-wrapper-block"
      topPattern={topPattern?.topPattern}
      mode={{
        currentMode,
        classNames: {
          LIGHT: "gronalund-primary",
          DARK: "gronalund-primary-dark",
        },
      }}
    >
      <SiteBlocks blocks={extendedBlocks} />
    </BackgroundWrapperBlockCore>
  );
};

export default withLivePreview(BackgroundWrapperBlock, backgroundWrapperBlockLivePreviewConfig);

export const fragmentBackgroundWrapperBlock = graphql`
  fragment BackgroundWrapperBlock on ContentfulBackgroundWrapperBlock {
    contentful_id
    id
    backgroundColorHex: backgroundColor {
      value
    }
    imageOpacity
    backgroundPattern {
      highQuality: gatsbyImageData(width: 600, quality: 100)
      lowQuality: gatsbyImageData(width: 300, quality: 70)
      file {
        url
      }
    }
    backgroundPatternCover
    topPattern {
      topPattern
    }
    backgroundMode
    blocks {
      __typename
      ...TextBlock
      ...CardListItemBlock
      ...FactBlock
      ...ListBlock
      ...ShowBlock
      ...RestaurantBlock
      ...RideBlock
      ...GeneralContentBlock
      ...MediaGalleryBlock
      ...HeroBlock
      ...ToolbarBlock
      ...AdmissionBlock
      ...UpcomingBlock
      ...DailyScheduleBlock
      ...ProductListBlock
      ...ProductBlock
      ...InformationBlock
      ...RestaurantMenuBlock
      ...FormBlock
      ...IframeCaspecoBlock
      ...ShowBookingBlock
      ...SeasonPassPurchaseBlock
      ...CountdownBlock
    }
  }
`;
